module.exports = {
	title: 'VSCode Power User | Learn Visual Studio Code | Video Course',
	url: 'https://vscode.pro/',
	urlNoTrailingSlash: 'https://vscode.pro',
	short_name: 'VSCode.pro',
	tag: 'VSCODEpro',
	description:
		"After 10 years with Sublime Text, I switched to VSCode — the new open source cross-platform editor everyone's talking about. I've spent over a 1,000 hours perfecting my setup to help you switch today and bring all your custom settings and the power user workflows for HTML/CSS, GitHub/Git & Open Source, supercharged Markdown, and everything from JavaScript to PHP, Go, Python, C++, C#, ROR & 50+ Extensions. → I'm sharing it all in five hours — 65 videos online course.",
	featuredImage: 'https://res.cloudinary.com/ahmadawais/image/upload/f_auto,q_auto/v1542317884/vscodepro-course.jpg',
	color: '#373277',
	icon: 'src/images/app_1024x1024.png',
	twitterHandle: '@MrAhmadAwais',
	countdownDate: `${new Date().getFullYear()}-03-20T00:00:00`,
	cachedCustomers: `14000`,
	// fullPrice: '149',
	// off: '40', // Percent off from 149.
	// now: '89', // Price.
	fullPrice: '164',
	off: '70', // Percent off from 149.
	now: '49', // Price.
	cpApiUrl: 'https://mails.ahmadawais.com/cpapi/index.php',
	getIpUrl:
		'https://api.ipstack.com/check?access_key=a7e242c521908c72eadcaf7baf320be4&output=json&fields=ip,country_code,country_name',
	getIpUrlBackup: 'https://freegeoip.app/json/',
	getCustomersCountUrl: 'https://mails.ahmadawais.com/cpapi/index.php',
	paddle: {
		vendorId: '16413',
		debug: false,
		eventCallback: function (data) {
			if (data.event === 'Checkout.PaymentComplete') {
				if (window.ga) {
					window.ga(`send`, `event`, {
						eventCategory: `CUSTOMER`,
						eventAction: `REGISTER`,
						eventLabel: `Paddle Checkout Success`,
						eventValue: Math.round(data.eventData.checkout.prices.vendor.total),
						transport: 'beacon',
					});
				}
			}
		},
	},
	intercom: {
		appId: 'plddz3bf',
	},
};
